import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styles from "../styles.module.scss";

/**
 * @description a component that used to show an ui error intereface for 403 errors
 */
const FourOThreePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className={styles.errorPage}>
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => navigate("/")}>
            Back Home
          </Button>
        }
      />
    </div>
  );
};

export default FourOThreePage;
